// extracted by mini-css-extract-plugin
export var actionText = "_jm-4";
export var container = "_jm-0";
export var leftSection = "_jm-1";
export var rightSection = "_jm-2";
export var settingsButton = "_jm-6";
export var settingsIcon = "_jm-7";
export var shortcut = "_jm-5";
export var shortcutGroup = "_jm-3";